import React from 'react';

const QuoteSummary = React.forwardRef(({ quote }, ref) => {
  if (!quote) return null;

  const calculateNights = () => {
    const checkinDate = new Date(quote.checkin_date);
    const checkoutDate = new Date(quote.checkout_date);
    const timeDiff = checkoutDate.getTime() - checkinDate.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('es-PE', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const services = quote.services_included?.split(',').map(s => s.trim()).filter(s => s) || [
    'Todas las habitaciones',
    'Uso exclusivo de instalaciones',
    'Limpieza diaria'
  ];

  return (
    <div ref={ref} style={{ width: '800px', padding: '40px', backgroundColor: '#fff', fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '30px', borderBottom: '3px solid #10b981', paddingBottom: '20px' }}>
        <h1 style={{ fontSize: '32px', color: '#10b981', margin: '0', fontWeight: 'bold' }}>SUMAQ MAYU</h1>
        <p style={{ fontSize: '14px', color: '#6b7280', margin: '5px 0 0 0' }}>Casa de Hospedaje</p>
        <div style={{ marginTop: '15px' }}>
          <p style={{ fontSize: '28px', color: '#1f2937', margin: '0', fontWeight: 'bold' }}>COTIZACIÓN</p>
          <p style={{ fontSize: '14px', color: '#6b7280', margin: '5px 0 0 0' }}>Casa Completa - Alquiler Exclusivo</p>
        </div>
      </div>

      {/* Info Cliente */}
      <div style={{ marginBottom: '25px' }}>
        <div style={{ backgroundColor: '#f3f4f6', padding: '15px', borderRadius: '8px', marginBottom: '15px' }}>
          <h2 style={{ fontSize: '18px', color: '#1f2937', margin: '0 0 10px 0', borderBottom: '2px solid #10b981', paddingBottom: '5px' }}>
            INFORMACIÓN DEL CLIENTE
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', fontSize: '14px' }}>
            <div>
              <strong style={{ color: '#4b5563' }}>Nombre:</strong>
              <p style={{ margin: '2px 0', color: '#1f2937' }}>{quote.full_name}</p>
            </div>
            <div>
              <strong style={{ color: '#4b5563' }}>DNI:</strong>
              <p style={{ margin: '2px 0', color: '#1f2937' }}>{quote.dni}</p>
            </div>
            <div>
              <strong style={{ color: '#4b5563' }}>Teléfono:</strong>
              <p style={{ margin: '2px 0', color: '#1f2937' }}>{quote.phone}</p>
            </div>
            <div>
              <strong style={{ color: '#4b5563' }}>Email:</strong>
              <p style={{ margin: '2px 0', color: '#1f2937', fontSize: '12px' }}>{quote.email}</p>
            </div>
            <div>
              <strong style={{ color: '#4b5563' }}>Ciudad:</strong>
              <p style={{ margin: '2px 0', color: '#1f2937' }}>{quote.city_of_origin}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Detalles de la Estadía */}
      <div style={{ marginBottom: '25px' }}>
        <div style={{ backgroundColor: '#eff6ff', padding: '15px', borderRadius: '8px' }}>
          <h2 style={{ fontSize: '18px', color: '#1f2937', margin: '0 0 10px 0', borderBottom: '2px solid #3b82f6', paddingBottom: '5px' }}>
            DETALLES DE LA ESTADÍA
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', fontSize: '14px' }}>
            <div>
              <strong style={{ color: '#4b5563' }}>Check-in:</strong>
              <p style={{ margin: '2px 0', color: '#1f2937', fontSize: '13px' }}>{formatDate(quote.checkin_date)}</p>
            </div>
            <div>
              <strong style={{ color: '#4b5563' }}>Check-out:</strong>
              <p style={{ margin: '2px 0', color: '#1f2937', fontSize: '13px' }}>{formatDate(quote.checkout_date)}</p>
            </div>
            <div>
              <strong style={{ color: '#4b5563' }}>Noches:</strong>
              <p style={{ margin: '2px 0', color: '#1f2937', fontSize: '20px', fontWeight: 'bold' }}>{calculateNights()}</p>
            </div>
            <div>
              <strong style={{ color: '#4b5563' }}>Huéspedes:</strong>
              <p style={{ margin: '2px 0', color: '#1f2937' }}>
                {quote.number_of_guests} adulto{quote.number_of_guests !== 1 ? 's' : ''}
                {quote.number_of_children > 0 && `, ${quote.number_of_children} niño${quote.number_of_children !== 1 ? 's' : ''}`}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Servicios Incluidos */}
      <div style={{ marginBottom: '25px' }}>
        <div style={{ backgroundColor: '#f0fdf4', padding: '15px', borderRadius: '8px' }}>
          <h2 style={{ fontSize: '18px', color: '#1f2937', margin: '0 0 10px 0', borderBottom: '2px solid #10b981', paddingBottom: '5px' }}>
            SERVICIOS INCLUIDOS
          </h2>
          <ul style={{ margin: '5px 0', paddingLeft: '20px', fontSize: '14px', color: '#1f2937' }}>
            {services.map((service, idx) => (
              <li key={idx} style={{ marginBottom: '5px' }}>{service}</li>
            ))}
          </ul>
        </div>
      </div>

      {/* Notas */}
      {quote.notes && (
        <div style={{ marginBottom: '25px' }}>
          <div style={{ backgroundColor: '#fef3c7', padding: '15px', borderRadius: '8px', border: '1px solid #fbbf24' }}>
            <h2 style={{ fontSize: '16px', color: '#92400e', margin: '0 0 8px 0' }}>
              📝 OBSERVACIONES
            </h2>
            <p style={{ margin: '0', fontSize: '14px', color: '#78350f', lineHeight: '1.5' }}>
              {quote.notes}
            </p>
          </div>
        </div>
      )}

      {/* Precio */}
      {quote.price && (
        <div style={{ marginBottom: '25px' }}>
          <div style={{ backgroundColor: '#10b981', padding: '20px', borderRadius: '8px', textAlign: 'center' }}>
            <p style={{ margin: '0', fontSize: '16px', color: '#fff', fontWeight: 'bold' }}>PRECIO TOTAL</p>
            <p style={{ margin: '10px 0 0 0', fontSize: '42px', color: '#fff', fontWeight: 'bold' }}>
              S/. {parseFloat(quote.price).toFixed(2)}
            </p>
            <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#d1fae5' }}>
              Por {calculateNights()} noche{calculateNights() !== 1 ? 's' : ''}
            </p>
          </div>
        </div>
      )}

      {/* Footer */}
      <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '2px solid #e5e7eb', textAlign: 'center' }}>
        <p style={{ fontSize: '12px', color: '#6b7280', margin: '5px 0' }}>
          📧 sumaqmayu@gmail.com | 📱 947791970
        </p>
        <p style={{ fontSize: '12px', color: '#6b7280', margin: '5px 0' }}>
          📍 Tarapoto, San Martín, Perú
        </p>
        <p style={{ fontSize: '11px', color: '#9ca3af', margin: '10px 0 0 0', fontStyle: 'italic' }}>
          Esta cotización es válida por 7 días desde su emisión
        </p>
        <p style={{ fontSize: '10px', color: '#d1d5db', margin: '5px 0 0 0' }}>
          Generado el {new Date().toLocaleDateString('es-PE')}
        </p>
      </div>
    </div>
  );
});

QuoteSummary.displayName = 'QuoteSummary';

export default QuoteSummary;
